import { render, staticRenderFns } from "./trend11x5.vue?vue&type=template&id=08ab8781"
import script from "./trend11x5.vue?vue&type=script&lang=js"
export * from "./trend11x5.vue?vue&type=script&lang=js"
import style0 from "./trend11x5.vue?vue&type=style&index=0&id=08ab8781&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports